import React from 'react'
import {
  ButtonActionBar,
  CreateGlobalProjectionModal,
  CustomBottomAction,
  DropdownMenu,
} from 'modules/core/components'
import { useTranslation } from 'react-i18next'
import { Input, Space } from 'antd'
import { SolutionOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import login from 'modules/login'

const { Search } = Input

const UserActionsGlobal = ({
  globalBudgetApproved,
  periodId,
  onFetchGlobalBudgetList,
  title,
  globalText,
  role,
  createGlobalProjection,
  type,
  fetchProjectionInstanceList,
  projectionInstanceList,
  setSearchValue,
  module_name,
  onClickActivity,
  loggedUser,
  sendUserDataToGTM,
}) => {
  const { t } = useTranslation()

  return (
    <ButtonActionBar>
      <Space direction="horizontal">
        <Search placeholder={t('ACTION_SEARCH')} allowClear={true} onSearch={setSearchValue} />
        <CreateGlobalProjectionModal
          globalBudgetApproved={globalBudgetApproved}
          periodId={periodId}
          title={title}
          globalText={globalText}
          role={role}
          onFetchGlobalBudgetList={onFetchGlobalBudgetList}
          text={t('LABEL_NEW').toLowerCase()}
          createGlobalProjection={createGlobalProjection}
          type={type}
          fetchProjectionInstanceList={fetchProjectionInstanceList}
          projectionInstanceList={projectionInstanceList}
          module={module_name}
          sendUserDataToGTM={sendUserDataToGTM}
        />
        <CustomBottomAction extraButtons={{ module_name: module_name }} />
        <DropdownMenu
          title={t('ACTION_MORE')}
          menu={[
            {
              title: t('ACTION_ACTIVITIES'),
              icon: <SolutionOutlined />,
              onClick: onClickActivity,
            },
          ]}
        />
      </Space>
    </ButtonActionBar>
  )
}

const mapStateToProps = (state) => ({
  loggedUser: login.selectors.getWhoAmI(state),
})

export default connect(mapStateToProps, null)(UserActionsGlobal)
